module.exports = __webpack_public_path__ + "img/Number=43.22e70e01.png";